import React from 'react'

import { Text } from './Text'

export const Question: React.FC<{text: string}> = ({ text: question }) => (
    <Text selectable={false} variant="q">
        {question}
    </Text>
)